import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const createClient = async (clientData, token) => {
  try {
    const payload = {
      name: clientData.name,
      tenant_id: clientData.tenantId,
      abbr: clientData.abbreviation
    };

    if (clientData.title) payload.title = clientData.title;
    if (clientData.description) payload.description = clientData.description;
    if (clientData.logoUrl) payload.logo_url = clientData.logoUrl;
    if (clientData.faviconUrl) payload.favicon_url = clientData.faviconUrl;
    if (clientData.theme) payload.theme = clientData.theme;
    if (clientData.font) payload.font = clientData.font;

    const response = await axios.post(`${BASE_URL}/user/v1/client`, payload, {
      headers: { 
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      }
    });

    const data = response.data.data;
    
    if (!data) {
      throw new Error('No client data received');
    }

    return {
      success: response.data.status === 0,
      client: {
        id: data.id,
        name: data.name,
        tenantId: data.tenantId,
        abbreviation: data.abbr,
        title: data.title,
        description: data.description,
        logoUrl: data.logoUrl,
        faviconUrl: data.faviconUrl,
        theme: data.theme,
        font: data.font
      }
    };
  } catch (error) {
    return handleError(error);
  }
};

export const getClientById = async (clientId, token) => {
  try {
    const response = await axios.get(`${BASE_URL}/user/v1/client/${clientId}`, {
      headers: { 
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      }
    });

    const data = response.data.data;
    
    if (!data) {
      throw new Error('No client data received');
    }

    return {
      success: response.data.status === 0,
      client: {
        id: data.id,
        name: data.name,
        tenantId: data.tenantId,
        abbreviation: data.abbr,
        title: data.title,
        description: data.description,
        logoUrl: data.logoUrl,
        faviconUrl: data.faviconUrl,
        theme: data.theme,
        font: data.font
      }
    };
  } catch (error) {
    return handleError(error);
  }
};

export const updateClient = async (clientData, token) => {
  try {
    const payload = {
      name: clientData.name
    }

    if (clientData.title) payload.title = clientData.title;
    if (clientData.description) payload.description = clientData.description;
    if (clientData.logoUrl) payload.logo_url = clientData.logoUrl;
    if (clientData.faviconUrl) payload.favicon_url = clientData.faviconUrl;
    if (clientData.theme) payload.theme = clientData.theme;
    if (clientData.font) payload.font = clientData.font;

    console.log("Payload", payload);
    // {"name" :"test"}
    const response = await axios.patch(`${BASE_URL}/user/v1/client/${clientData.id}`, JSON.stringify(payload), {
      headers: {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      }
    })

    const result = response.data
    console.log("Response", result);


    const data = result.data


    if (!data) {
      throw new Error('No client data received')
    }

    return {
      success: result.status === 0,
      client: {
        id: data.id,
        name: data.name,
        tenantId: data.tenantId,
        abbreviation: data.abbr,
        title: data.title,
        description: data.description,
        logoUrl: data.logoUrl,
        faviconUrl: data.faviconUrl,
        theme: data.theme,
        font: data.font
      }
    }
  } catch (error) {
    return handleError(error)
  }
}

export const deleteClient = async (clientId, token) => {
  try {
    const response = await axios.delete(`${BASE_URL}/user/v1/client/${clientId}`, {
      headers: { 
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      }
    });

    return {
      success: response.data.success && response.data.status === 0,
      message: response.data.message
    };
  } catch (error) {
    return handleError(error);
  }
};

export const addUserToClient = async (clientId, userId, userType, token) => {
  try {
    const response = await axios.post(`${BASE_URL}/user/v1/client/${clientId}/user/${userId}`, {
      type: userType
    }, {
      headers: { 
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      }
    });

    return {
      success: response.data.success && response.data.status === 0,
      message: response.data.message
    };
  } catch (error) {
    return handleError(error);
  }
};

export const removeUserFromClient = async (clientId, userId, token) => {
  try {
    const response = await axios.delete(`${BASE_URL}/user/v1/client/${clientId}/user/${userId}`, {
      headers: { 
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      }
    });

    return {
      success: response.data.success && response.data.status === 0,
      message: response.data.message
    };
  } catch (error) {
    return handleError(error);
  }
};

export const getAllClients = async (params, token) => {
  try {
    // Build query parameters
    const queryParams = new URLSearchParams();
    
    // Add pagination parameters if provided
    if (params.pagination) {
      queryParams.append('pagination.page', params.pagination.page || 1);
      queryParams.append('pagination.page_size', params.pagination.pageSize || 10);
    }
    
    // Add sorting parameters if provided
    if (params.sorting) {
      queryParams.append('sorting.sort_by', params.sorting.sort_by);
      queryParams.append('sorting.order', params.sorting.order);
    }
    
    // Add name filter if provided
    if (params.nameFilter) {
      queryParams.append('name_filter', params.nameFilter);
    }
    
    const url = `${BASE_URL}/user/v1/clients?${queryParams.toString()}`;
    
    const response = await axios.get(url, {
      headers: { 
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      }
    });

    const responseData = response.data;
    
    if (!responseData.data) {
      throw new Error('No client data received');
    }

    return {
      success: responseData.status === 0,
      clients: responseData.data.map(client => ({
        id: client.id,
        name: client.name,
        tenantId: client.tenantId,
        abbreviation: client.abbr,
        title: client.title,
        description: client.description,
        logoUrl: client.logoUrl,
        faviconUrl: client.faviconUrl,
        theme: client.theme,
        font: client.font
      })),
      pagination: {
        totalCount: responseData.totalCount,
        pageCount: responseData.pageCount,
        page: responseData.page,
        pageSize: responseData.pageSize
      }
    };
  } catch (error) {
    return handleError(error);
  }
};

const handleError = (error) => {
  console.error('Client API Error:', error);
  
  if (error.response?.status === 503) {
    return {
      success: false,
      error: 'Service temporarily unavailable'
    };
  }
  
  return {
    success: false,
    error: error.response?.data?.message || error.message || 'Operation failed'
  };
}; 